import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Footer } from './Footer';
export function ClosingSection() {
  return <section className="pt-20 pb-10 px-4 bg-warm-gray watermark-bg" data-id="element-11">
      <div className="max-w-3xl mx-auto text-center" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold mb-10" data-id="element-14">
            One Last Thing Before You Decide
          </h2>

          <div className="space-y-6 text-lg text-charcoal/90 leading-relaxed mb-12 text-left max-w-2xl mx-auto" data-id="element-15">
            <p data-id="element-16">You didn't pick up this page by accident.</p>

            <p data-id="element-17">
              There's a decision in your life right now that has been louder
              than it should be.
            </p>

            <p data-id="element-18">
              You've been patient. You've been prayerful. You've been waiting
              for clarity that feels like it's always just out of reach.
            </p>

            <p className="font-bold pt-4" data-id="element-19">Here's what I want you to know:</p>

            <p data-id="element-20">
              You are not broken. You are not spiritually weak. You are not
              behind.
            </p>

            <p data-id="element-21">
              You are simply missing a framework. And frameworks can be learned
              in 5 minutes.
            </p>
          </div>

          <blockquote className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-gold/20 mb-12 relative" data-id="element-22">
            <div className="absolute top-4 left-4 text-6xl text-gold/20 font-serif leading-none" data-id="element-23">
              "
            </div>
            <p className="font-serif italic text-xl md:text-2xl text-charcoal leading-relaxed relative z-10" data-id="element-24">
              Your peace is not a destination you find — it is a signal you tune
              into. Clarity doesn't come from knowing the whole map, but from
              having the courage to take the next right step with a regulated
              heart.
              <br data-id="element-25" />
              <br data-id="element-26" />
              You are no longer guessing. You are discerning.
              <br data-id="element-27" />
              <br data-id="element-28" />
              Welcome to a life governed by peace, not pressure.
            </p>
            <footer className="mt-6 font-sans text-sm font-bold text-gold uppercase tracking-widest" data-id="element-29">
              — GraceLife by GoDeskCore
            </footer>
          </blockquote>

          <div className="mb-16" data-id="element-30">
            <CTAButton mainText="YES. I'M READY FOR CLARITY." subText='Get "Is This God or My Fear?" — $17.95 | Instant Download | PDF Toolkit | 14-Day Guarantee' large className="max-w-xl" data-id="element-31" />
            <p className="mt-6 font-serif italic text-charcoal/70" data-id="element-32">
              "Turn a loud relationship decision into a clear next step —
              tonight."
            </p>
          </div>
        </motion.div>
      </div>

      <Footer data-id="element-33" />
    </section>;
}